
      window.dataLayer = window.dataLayer || []

      function gtag() {
        window.dataLayer.push(arguments)
      }

      window.gtag = gtag

      gtag("consent", "default", {
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        analytics_storage: "denied",
      })

      const gtmId = import.meta.env.VITE_GTM_CONTAINER_ID

      if (gtmId) {
        window.dataLayer.push({
          "gtm.start": new Date().getTime(),
          event: "gtm.js",
        })

        const gtmScript = document.createElement("script")
        gtmScript.async = true
        gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`
        gtmScript.onload = () => {
          const noscript = document.getElementById("gtm-noscript")
          if (noscript) {
            noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`
          }
        }

        document.head.appendChild(gtmScript)
      }
    